export default {
    data() {
        return {
            //题目的偏移量
            topicOffset: 0,
            //题目请求的条数
            topicLength: 15,
            //查询时候的题目名字
            topicSearchName: '',
            //题目的总条数
            topicTotal: 0,
            //添加题目的弹窗
            dialogTableVisible: false,
            //修改题目的弹窗
            dialogTableVisiblexiugai: false,
            //课后习题的资源
            afterClass: [],
            //添加题目的标题
            topicText: "",
            //添加题目的data
            topicData: "",
            //修改题目时候的标题
            updateTopciText: "",
            //修改题目时候需要的data，即内容
            updateTopciData: "",
            //修改题目时候需要的id
            updateTopicId: ""
        }
    },
    methods: {
        //确定添加一个课后习题
        confirmAddTopic() {
            //校验添加题目是否为空
            if (this.topicText == "" || this.topicData == "") {
                this.$message({
                    message: "题目标题和内容均不能为空!",
                    type: "error"
                })
                return false;
            }
            //发送给后台的数据
            let data = {
                token: this.$store.state.authority_management,
                name: this.topicText,
                data: this.topicData,
                type: "7",
            };
            //发送请求创建
            this.$post("resources/shop_create", data).then(res => {
                if (res.data.status == "success") {
                    this.$message({
                        message: "题目创建成功!",
                        type: "success"
                    })
                    //清空输入框
                    this.topicText = "";
                    this.topicData = "";
                    //关闭弹窗
                    this.dialogTableVisible = false;
                    //刷新数据
                    this.getTopics();
                } else {
                    this.$message({
                        message: "题目创建失败!",
                        type: "error"
                    })
                }
            })
        },
        //弹窗编辑弹窗
        updateTopic(obj) {
            //弹出弹窗
            this.dialogTableVisiblexiugai = true;
            //获取id
            this.updateTopicId = obj.id;
            //获取试题题目
            this.updateTopciText = obj.name;
            //获取简单题内容
            this.updateTopciData = obj.data;
        },
        //确定修改一个课后习题
        confirmUpdateTopic() {
            //校验添加题目是否为空
            if (this.updateTopciText == "" || this.updateTopciData == "") {
                this.$message({
                    message: "题目标题和内容均不能为空!",
                    type: "error"
                })
                return false;
            }
            //发送给后台的数据
            let data = {
                id: this.updateTopicId,
                token: this.$store.state.authority_management,
                name: this.updateTopciText,
                data: this.updateTopciData,
                type: "7",
            };
            //发送请求创建
            this.$post("resources/shop_edit", data).then(res => {
                if (res.data.status == "success") {
                    this.$message({
                        message: "修改成功!",
                        type: "success"
                    })
                    //清空输入框和id
                    this.updateTopicId = "";
                    this.updateTopciText = "";
                    this.updateTopciData = "";
                    //关闭弹窗
                    this.dialogTableVisiblexiugai = false;
                    //刷新数据
                    this.getTopics();
                } else {
                    this.$message({
                        message: "修改失败!",
                        type: "error"
                    })
                }
            })

        },
        //删除简答题目资源
        deleteTpoic(id) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //删除发送给后台的数据
                let data = {
                    token: this.$store.state.authority_management,
                    id: id
                };
                //删除发起的请求
                this.$post("resources/delete", data).then(res => {
                    if (res.data.status == 'success') {
                        this.$message({
                            message: "删除成功!",
                            type: "success"
                        })
                        //删除成功后刷新数据
                        this.getTopics();
                    } else {
                        this.$message({
                            message: "删除失败!",
                            type: "error"
                        })
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //获取课后习题资源
        getTopics() {
            //发送的请求的数据
            let data = {
                offset: this.topicOffset,
                length: this.topicLength,
                name: this.topicSearchName,
                type: '7',
                token: this.$store.state.authority_management
            }
            //发送查询的请求
            this.$post("resources/shop_search", data).then(res => {
                // console.log(res.data);
                this.topicTotal = res.data.result.total;
                this.afterClass = res.data.result.data;
            })
        },
        //当请求条数发生变化时候
        handleSizeChange(val) {
            //改变请求条数
            this.topicLength = val;
            //重新刷新数据
            this.getTopics();
        },
        //当页数发生改变时候触发
        handleCurrentChange(val) {
            //改变偏移量
            this.topicOffset = (val - 1) * this.topicLength;
            //重新刷新数据
            this.getTopics();
        }
    },
    created() {
        this.getTopics();
    }
}